// styles/Header.styles.js
import theme from './../../theme';

const HeaderStyles = {
  /* ───────────────────  Top contact bar  ─────────────────── */
  contactBar: {
    backgroundColor: '#000000',
    padding: { xs: '5px 16px', md: '5px 40px' },
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '20px',
    borderBottom: '1px solid #81c241',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
  },
  contactText: {
    color: 'white',
    fontFamily: theme.fonts.primary,
    fontSize: '0.9rem',
    fontWeight: 'normal',
    '&:hover': { color: '#81c241' },
  },

  /* ───────────────────  AppBar / Toolbar  ─────────────────── */
  appBar: {
    backgroundColor: '#000000',
    padding: { xs: '10px 16px', md: '10px 40px' },
    boxShadow: 'none',
    borderBottom: '2px solid #81c241',
    overflowX: 'hidden',              // prevent accidental scroll
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 'auto',
  },

  /* ───────────────────  Logo  ─────────────────── */
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  logo: {
    height: { xs: 50, sm: 60, md: 200 },
    maxWidth: { xs: 140, sm: 165, md: 'unset' },
    width: 'auto',
    objectFit: 'contain',
    display: 'block',
    cursor: 'pointer',
  },

  /* ───────────────────  Desktop nav  ─────────────────── */
  navLinks: {
    display: 'flex',
    gap: '30px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  link: {
    fontFamily: theme.fonts.primary,
    color: theme.colors.white,
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    transition: 'all 0.3s ease',
    '&:hover': { color: theme.colors.green },
  },

  /* ───────────────────  Auth buttons  ─────────────────── */
  authButtons: {
    display: 'flex',
    alignItems: 'center',
  },
  loginButton: {
    fontFamily: theme.fonts.primary,
    color: '#000000',
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    transition: 'all 0.3s ease',
    '&:hover': { color: '#81c241' },
  },
  dashboardButton: {
    fontFamily: theme.fonts.primary,
    color: '#81c241',
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    mr: 1,
    transition: 'all 0.3s ease',
    '&:hover': { color: '#81c241' },
  },
  logoutButton: {
    fontFamily: theme.fonts.primary,
    color: '#81c241',
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    transition: 'all 0.3s ease',
    '&:hover': { color: '#81c241' },
  },

  /* ───────────────────  Mobile drawer  ─────────────────── */
  mobileDrawer: {
    backgroundColor: '#000000',
    height: '100%',
    p: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  mobileListItem: {
    fontFamily: theme.fonts.primary,
    color: 'white',
    fontSize: '1rem',
    textTransform: 'capitalize',
    py: 1.5,
    borderBottom: '1px solid #333',
    '&:hover': {
      color: '#81c241',
      backgroundColor: 'rgba(255,255,255,0.05)',
    },
  },
  mobileDrawerText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem',
    fontFamily: theme.fonts.primary,
    textTransform: 'capitalize',
  },
};

export default HeaderStyles;
